<template>
  <div class="modal" v-if="signinForm.createdAt">
    <v-dialog :value="value" @input="$emit('input')" fullscreen transition="fade-transition">
      <v-card tile>
        <v-toolbar
          class="mb-12"
          color="secondary"
          elevate-on-scroll>
          <v-toolbar-title class="headline">Creator Signin Form</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container class="view-signinform-container" fluid>
          <v-form class="sign-in-form" ref="signInForm" v-model="valid" lazy-validation>
            <v-layout wrap justify-center mb-2>
              <v-flex xs12 md7>
                <v-row>
                  <v-col cols="12">
                    <p class="default-title font-weight-bold mb-2">Date: {{utils.formatCustomDate(signinForm.createdAt, 'DD/MM/YYYY')}}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <p class="address-title">
                      Kobe Global Technologies Pte Ltd.<br />
                      GST Registration no. 201608755R<br />
                      51 Goldhill Plaza<br />
                      #14-01<br />
                      Singapore 308900<br />
                      finance@getkobe.com
                    </p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <p class="default-title mb-2"><span class="font-weight-bold">Client:</span> {{displayData.clientName}}</p>
                  </v-col>
                </v-row>
                <v-row class="mb-2">
                  <v-col cols="12">
                    <p class="default-title mb-2"><span class="font-weight-bold">Campaign Name:</span> {{displayData.campaignName}}</p>
                    <p class="default-title mb-2"><span class="font-weight-bold">Creator:</span> @{{displayData.handle}} on {{displayData.platform}}</p>
                    (
                      <a :href="`https://www.youtube.com/@${displayData.handle}`" v-if="platform === 'youtube'" target="_blank">https://www.youtube.com/{{displayData.handle}}</a>
                      <a :href="`https://www.tiktok.com/@${displayData.handle}`" v-else-if="platform === 'tiktok'" target="_blank">https://www.tiktok.com/{{displayData.handle}}</a>
                      <a :href="`https://www.instagram.com/${displayData.handle}`" v-else target="_blank">https://www.instagram.com/{{displayData.handle}}</a>
                    )
                  </v-col>
                </v-row>
                <terms-and-conditions />
                <v-row>
                  <v-col cols="12">
                    <div class="text-right" style="max-width:420px">
                      <div style="border: 1px solid #cfcece;margin-bottom: 10px;">
                        <canvas id="signin-signature-pad" class="cls-signature-pad" style="display:none" width=400 height=200></canvas>
                        <img :src="signatureImg" width=400 height=200 />
                      </div>
                    </div>
                    <p class="default-title mb-2">Signature</p>
                  </v-col>
                </v-row>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <v-card-actions>
          <v-row style="margin-bottom:10px !important;">
            <v-col cols="12" align="right" style="margin-right:20px">
              <v-container >
                <v-btn
                  :loading="downloadloading"
                  :disabled="downloadloading"
                  color="blue-grey"
                  class="ma-2 white--text"
                  @click='downloadPDF'
                  >Download
                  <v-icon right dark>mdi-cloud-download</v-icon>
                </v-btn>
              </v-container>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import SignaturePad from 'signature_pad';
import utils from '@/utils';
import TermsAndConditions from './TermsAndConditions'
import campaignAPIs from '../../Campaign/campaignAPIs'
export default {
  name: 'ViewSigninForm',
  props: {
    value: Boolean,
    signinFormData: Object
  },
  components: {
    TermsAndConditions
  },
  data () {
    return {
      utils: utils.func,
      campaign: {},
      displayData: {},
      signinForm: {},
      signaturePad: null,
      signatureImg: null,
      downloadloading: false
    }
  },
  watch: {
    signinFormData: async function(newValue) {
      this.signinForm = newValue.signinForm
      this.campaign = await campaignAPIs.getCampaignDetailForFeedback(newValue.CampaignID)
      let infDetails = newValue.influencer_details
      this.displayData = Object.assign({}, {
        handle: infDetails.instagramHandle,
        platform: infDetails.platform,
        campaignName: this.campaign.name,
        clientName: this.campaign.client ? this.campaign.client.name : '-'
      })
      // load signature
      var canvas = document.getElementById('signin-signature-pad')
      this.signaturePad = new SignaturePad(canvas, {
        backgroundColor: 'rgb(255, 255, 255)'
      })
      this.signaturePad.fromData(this.signinForm.signature);
      this.signatureImg = this.signaturePad.toDataURL();
    }
  },
  methods: {
    downloadPDF() {
      // impl download here
    },
    close() {
      this.$emit('input');
    }
  }
}
</script>
<style scoped>
  .default-title {
    font-size: 18px;
  }

  .address-title {
    line-height: 1.8rem;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// ViewModalDialog.vue?1c916f48